import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, RefreshCcw } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleRetry = () => {
    // Try to get the last known good path from session storage
    const lastPath = sessionStorage.getItem("lastPath") || "/landing";
    navigate(lastPath);
    toast({
      title: "Reconnecting...",
      description: "Taking you back to your last location",
    });
  };

  const goHome = () => {
    navigate("/landing");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-4 text-center">
      <h1 className="text-4xl font-bold mb-4">Oops!</h1>
      <p className="text-muted-foreground mb-8">
        It seems we've lost our way. Let's get you back on track.
      </p>
      <div className="flex flex-col sm:flex-row gap-4">
        <Button onClick={handleRetry} className="gap-2">
          <RefreshCcw className="h-4 w-4" />
          Try Again
        </Button>
        <Button onClick={goHome} variant="outline" className="gap-2">
          <Home className="h-4 w-4" />
          Go to Home
        </Button>
      </div>
    </div>
  );
};